import React, {Component} from "react";
import {connect} from "react-redux";
import classNames from "classnames";
import FJToolbarCommon from "../view/FJToolbarCommon";
import FJToolbarCrop from "../view/FJToolbarCrop";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";

class FJToolbarCropContainer extends Component {
  render() {
    let containerClass = classNames('c-toolbar-crop', {active: this.props.active});
    let {handleCropSquare, handleCropCircle, handleResetCrop, handleCancelCrop, handleSureCrop} = this.props;
    return (
      <FJToolbarCommon className={containerClass}>
        <FJToolbarCrop handleCropSquare={handleCropSquare}
                       handleCropCircle={handleCropCircle}
                       handleResetCrop={handleResetCrop}
                       handleCancelCrop={handleCancelCrop}
                       handleSureCrop={handleSureCrop}/>
      </FJToolbarCommon>
    )
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    handleCropSquare: function () {
      dispatch(FJToolbarAction.changeMaskAction(1));
    },
    handleCropCircle: function () {
      dispatch(FJToolbarAction.changeMaskAction(2));
    },
    handleResetCrop: function () {
      dispatch(FJToolbarAction.changeMaskAction(0));
    },
    handleCancelCrop: function () {
      dispatch(FJToolbarAction.setCropAction(false, true));
    },
    handleSureCrop: function () {
      dispatch(FJToolbarAction.setCropAction(false));
    },
  }
}

export default connect(null, mapDispatchToProps)(FJToolbarCropContainer);
